import http from '../../utils/fetch';
export default {
    baseurl:'/api/bsc/redismana',
    list(query){
        return http({
            url: this.baseurl+'/selectList',
            method: 'post',
            params: query
        });
    },
    clearkey(key){
        return http({
            url: this.baseurl+'/clearkey',
            method: 'post',
            params: {key}
        });
    },
}
